<template>
    <v-form
            ref="modifyEmpForm"
            @submit.prevent=""
            class="fill-height of-y"
            :disabled="loading"
    >
        <div class="">
            <div class="d-flex align-center primary pl-3 pr-2">
                <div class="flex-grow-1 sub--text">
                    {{`Edit ${selectedEmployees.length} Employees`}}
                </div>
            </div>
            <v-divider></v-divider>

            <div class="d-flex align-center px-2 pb-1">
                <div class="flex-grow-1 pr-2" style="overflow-x: hidden; overflow-y: hidden">
                    <v-autocomplete
                            label="Farm"
                            hide-details="auto"
                            no-data-text="No available farms"
                            v-model="selectedFarm"
                            item-text="description"
                            item-value="id"
                            :items="disabledFarms"
                            clearable
                            class="pb-1 pt-3"
                            dense
                    />
                </div>
<!--                @click="validateSave()"-->
                <v-btn
                        fab
                        small
                        color="secondary"
                        :loading="loading"
                        :disabled="!selectedFarm || loading"
                        @click="saveChangesFarm()"
                >
                    <v-icon>mdi-content-save</v-icon>
                </v-btn>

            </div>

            <div class="d-flex align-center px-2 pb-1">
                <div class="flex-grow-1 pr-2" style="overflow-x: hidden; overflow-y: hidden">
                    <v-autocomplete
                            dense
                            label="Team"
                            hide-details="auto"
                            no-data-text="No available farms"
                            v-model="selectedTeam"
                            item-text="description"
                            item-value="id"
                            :items="teams"
                            clearable
                            class="pb-1 pt-3"
                    />
                </div>
                <!--                @click="validateSave()"-->
                <v-btn
                        fab
                        small
                        color="secondary"
                        :loading="loading"
                        :disabled="!selectedTeam || loading"
                        @click="updateTeam()"
                >
                    <v-icon>mdi-content-save</v-icon>
                </v-btn>

            </div>

        </div>

        <v-dialog v-model="createTeamShow" width="400">
            <v-card>
                <div class="d-flex align-center primary pl-3 pr-2">
                    <div class="flex-grow-1 sub--text">
                        Create Team
                    </div>
                        <v-btn
                                icon
                                color="white"
                                small
                                @click="createTeamShow = false"
                        >
                            <v-icon small>mdi-close</v-icon>
                        </v-btn>
                </div>
                <v-divider></v-divider>
                <div class="px-2 pb-1" style="overflow-x: hidden; overflow-y: hidden">
                    <v-text-field
                            label="Team Name"
                            placeholder="eg. Team 1"
                            hide-details="auto"
                            v-model="createTeamDescription"
                            :rules="[validationRules.required]"
                    />
                </div>
                <v-divider></v-divider>
                <div class="d-flex justify-end pa-2">
                    <v-btn
                            small
                            color="primary"
                            :disabled="!createTeamDescription"
                            @click="saveChangesTeam()"
                    >Create Team & Save</v-btn>
                </div>
            </v-card>

        </v-dialog>

    </v-form>
</template>

<script>
import {mapGetters} from 'vuex'
import {validationRules} from "../../../core/codeFunctions";

export default {
    components: {},
    props: {
        selectedEmployees: Array
    },
    data() {
        return {
            employee: null,
            loading: false,
            validationRules: validationRules,
            selectedFarm: null,
            selectedTeam: null,
            createTeamShow: false,
            createTeamDescription: null
        }
    },
    watch: {
        selectedEmployees: {
            deep: true,
            immediate: true,
            handler(val) {
                this.changesMade = false
                this.selectedFarm = null;
                this.selectedTeam = null;
            }
        },
    },
    methods: {

        updateTeam() {
            if (this.selectedTeam === 'Create New Team') {
                this.createTeamDescription = null;
                this.createTeamShow = true
            } else {
                this.saveChangesTeam()
            }


        },


        saveChangesTeam() {
            if (this.createTeamShow && !this.createTeamDescription) {
                this.$snack.error('Team Description is required')
                return
            }
            this.loading = true;
            this.createTeamShow = false;
            this.$newReq('POST', 'setup/team', {team: this.createTeamDescription || this.selectedTeam, emps: this.selectedEmployees})
                    .then((res) => {
                        this.emp.forEach(emp => {
                            if (this.selectedEmployees.includes(emp.id))
                                emp.team = this.createTeamDescription || this.selectedTeam
                        })
                        this.createTeamDescription = null;
                        this.$snack.info('Team Changes Saved (Please Refresh)')
                    })
                    .catch(e => {
                        console.log(e)
                        this.$snack.netWorkError();
                        this.createTeamDescription = null;
                    })
                    .finally(() => {
                        this.loading = false
                    })
        },

        saveChangesFarm() {
            if (!this.selectedFarm) {
                this.$snack.error('farm is required')
                return
            }
            this.loading = true;
            this.createTeamShow = false;
            this.$newReq('POST', 'setup/empFarm', {farm: this.selectedFarm, emps: this.selectedEmployees})
                    .then((res) => {
                        this.emp.forEach(emp => {
                            if (this.selectedEmployees.includes(emp.id))
                                emp.fkFarm = this.selectedFarm
                        })
                        this.$snack.info('Farm Changes Saved (Please Refresh)')
                    })
                    .catch(e => {
                        console.log(e)
                        this.$snack.netWorkError();
                        this.createTeamDescription = null;
                    })
                    .finally(() => {
                        this.loading = false
                    })
        }

    },
    computed: {
        ...mapGetters(['emp', 'farms', 'availableFarms']),

        teams() {
            return [
                    "Create New Team",
                    ...this.emp.reduce((list, emp) => {
                        return !emp.team || list.includes(emp.team) ? list : list.concat(emp.team)
                    }, []).sort((a,b)=>a>b?1:-1)
            ]
        },


        disabledFarms() {
            const availableFarmsArr = this.availableFarms.map(obj => obj.id)
            return this.farms.map(farm => {
                return {
                    ...farm,
                    disabled: !availableFarmsArr.includes(farm.id)
                }
            })
        }
    },
}
</script>

<style scoped>

</style>